import onUserHasConsentedToCookies from "../../../../../../CodeQ.Site/Resources/Private/Fusion/onUserHasConsentedToCookies";

export default class UserGeneratedImageForm {
	static init() {
		onUserHasConsentedToCookies('statistics', () => UserGeneratedImageForm.initInternal(), true);
	}

	static initInternal() {
		if (!window.grecaptcha || !grecaptcha.execute) {
			// is page is not yet fully loaded
			setTimeout(() => UserGeneratedImageForm.initInternal(), 200);
		} else {
			Array.from(document.querySelectorAll('.user-generated-image-form')).forEach(el => {
				new UserGeneratedImageForm(el);
			});
		}
	}

	constructor (form) {
		if (!form) {
			return;
		}

		const isInlineForm = form.classList.contains('user-generated-image-form--inline')
		let popup = form.querySelector('.user-generated-image-form-popup');
		const uploadButton = document.querySelector('.user-generated-image-form-upload-button')

		if (uploadButton) {
			form.classList.remove('d-none')
			uploadButton.classList.remove('d-none')
		}

		// get the username from the get parameter
		function findGetParameter(parameterName) {
			let result = null,
				tmp = [];
			location.search
				.substr(1)
				.split("&")
				.forEach(function (item) {
					tmp = item.split("=");
					if (tmp[0] === parameterName) result = decodeURIComponent(tmp[1]);
				});
			return result;
		}
		if (findGetParameter('displayName')) {
			let displayName = findGetParameter('displayName');
			displayName = displayName.replace(/\+/g, ' '); // The app wrongfully replaces space with '+'
			form.querySelector('#user').value = displayName;
		}

		let contentImage = form.querySelector('#contentImage');
		if (contentImage) {
			const onContentImageChange = function () {
				let input = this;
				if (input.files && input.files[0]) {
					let reader = new FileReader();

					reader.onload = function (e) {
						document.body.classList.add('user-generated-image--popup-open');
						popup.classList.remove('hidden');
						let image = form.querySelector('.user-generated-image-preview');
						image.setAttribute('src', e.target.result);
						document.querySelector('#contentText').focus();
					};

					reader.readAsDataURL(input.files[0]);
				}
			};
			contentImage.addEventListener('change', onContentImageChange, false);
			onContentImageChange.apply(contentImage);
		}

		//
		// Set reCaptchaToken form field
		//
		let recaptchaInput = form.querySelector('#reCaptchaToken');
		if (recaptchaInput) {
			let websiteKey = document.body.dataset.recaptchaWebsiteKey;
			if (!window.grecaptcha) {
				console.error('grecaptcha library not available or no consent given');
			} else if (!websiteKey) {
				window.alert('reCaptcha wurde nicht korrekt konfiguriert!');
				console.error('websiteKey not set on the body');
			} else {
				grecaptcha.ready(function () {
					grecaptcha.execute(websiteKey, {action: 'post'})
						.then(function (reCaptchaToken) {
							form.querySelector('#reCaptchaToken').value = reCaptchaToken;
						})
						.catch(function () {
							console.error('recaptcha could not validate user for UserGeneratedPost.Form');
						});
				});
			}
		}

		let backButton = form.querySelector('.user-generated-image-back-button');
		if (backButton) {
			backButton.addEventListener('click', function(e) {
				e.preventDefault();
				contentImage.value = null;
				document.body.classList.remove('user-generated-image--popup-open');
				popup.classList.add('hidden');
			}, false);
		}

		let contentText = form.querySelector('#contentText');
		let submitButton = form.querySelector('button[type="submit"]');

		// on textarea enter, submit the image
		if (contentText) {
			contentText.addEventListener('keypress', function(e) {
				if (e.keyCode === 13 && !isInlineForm) {
					e.preventDefault();
					form.submit();
					submitButton.innerHTML = 'Hochladen...';
					setTimeout(function() {
						contentText.setAttribute('disabled', 'disabled');
						submitButton.setAttribute('disabled', 'disabled');
					}, 100);
				}
			}, false);
		}

		//
		// If there is a flash message, auto-hide
		//
		let alert = form.querySelector('.user-generated-image-form-alert')
		if (alert) {
			alert.addEventListener('click', function() {
				alert.classList.add('hidden');
			}, false);
			setTimeout(function() {
				alert.classList.add('hidden');
			}, 5000);
		}

		// Inline Form
		if (isInlineForm) {
			form.addEventListener('change', () => validateForm(form))
			form.addEventListener('keydown', () => validateForm(form))
			window.userGeneratedImageUpload.on("success", () => validateForm(form))

			const youtubeVideoUriField = form.querySelector('#youtubeVideoUri')
			youtubeVideoUriField.addEventListener('change', () => onYoutubeVideoUriEntered(form))
			youtubeVideoUriField.addEventListener('keydown', () => onYoutubeVideoUriEntered(form))
			window.userGeneratedImageUpload.on("addedfile", () => onAddedFile(form))

			form.addEventListener('submit', (event) => {
				const isValid = validateForm(form);
				if (!isValid) {
					event.preventDefault()
				}
			});
		}

		const onYoutubeVideoUriEntered = function(form) {
			const youtubeVideoUriField = form.querySelector('#youtubeVideoUri')
			const uploadForm = document.querySelector('#userGeneratedFileUpload')

			console.log('youtube video uri entered', youtubeVideoUriField.value.length)

			if (youtubeVideoUriField.value.length > 0) {
				uploadForm.classList.add('disabled')
			} else {
				uploadForm.classList.remove('disabled')
			}
		}

		const onAddedFile = function(form) {
			console.log('dropzone file added')
			const youtubeVideoUriField = form.querySelector('#youtubeVideoUri')
			youtubeVideoUriField.value = ''
			youtubeVideoUriField.setAttribute('disabled', 'disabled')
		}

		const validateForm = function(form) {
			const submitButton = form.querySelector('button[type="submit"]')
			const reCaptchaTokenField = form.querySelector('#reCaptchaToken')
			const uploadedAssetIdentifierField = form.querySelector('#uploadedAssetIdentifier')
			const youtubeVideoUriField = form.querySelector('#youtubeVideoUri')
			const emailField = form.querySelector('#email')
			const optInField = form.querySelector('#optIn')

			if (
				reCaptchaTokenField.value.length > 0 &&
				(uploadedAssetIdentifierField.value.length > 0 || youtubeVideoUriField.value.length > 0) &&
				emailField.value.length > 0 &&
				emailField.value.indexOf('@') >= 0 &&
				optInField.checked
			) {
				submitButton.classList.remove('disabled')
				return true
			} else {
				submitButton.classList.add('disabled')
				return false
			}
		}

		// Form On Submit
		form.addEventListener('submit', () => {
			const userField = form.querySelector('#user')
			const emailField = form.querySelector('#email')
			const optInField = form.querySelector('#optIn')
			const newsletterOptInField = form.querySelector('#userNewsletterOptIn')
			const youtubeVideoUriField = form.querySelector('#youtubeVideoUri')
			const uploadedAssetIdentifierField = form.querySelector('#uploadedAssetIdentifier')

			if (youtubeVideoUriField && youtubeVideoUriField.value.length > 0) {
				form.removeChild(uploadedAssetIdentifierField)
			}

			setTimeout(function() {
				submitButton.innerHTML = 'Hochladen...';
				contentText.setAttribute('disabled', 'disabled');
				submitButton.setAttribute('disabled', 'disabled');
				userField.setAttribute('disabled', 'disabled');
				if (emailField) emailField.setAttribute('disabled', 'disabled');
				if (optInField) optInField.setAttribute('disabled', 'disabled');
				if (newsletterOptInField) newsletterOptInField.setAttribute('disabled', 'disabled');
				if (youtubeVideoUriField) youtubeVideoUriField.setAttribute('disabled', 'disabled');
			}, 100);
		})
	}
}
